import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

import { createVouchers as createOfferVouchersApi } from "../../../../services/dashboard/apiOffers";

export function useCreateOfferVouchers() {
  const queryClient = useQueryClient();

  const {
    mutate: createOfferVouchers,
    isLoading: isCreating,
    error,
    data: vouchers,
  } = useMutation({
    mutationFn: createOfferVouchersApi,
    onSuccess: () => {
      toast.success("تم إنشاء الأكواد بنجاح");
      queryClient.invalidateQueries({
        queryKey: ["offerVouchers"],
      });
    },

    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { createOfferVouchers, isCreating, error, vouchers };
}
